import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Constants } from '../../interfaces/constants';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-nav-map',
	standalone: true,
	imports: [MatIconModule, TranslateModule],
	templateUrl: './nav-map.component.html',
	styleUrl: './nav-map.component.scss',
})
export class NavMapComponent implements OnChanges {
	public activeRoute:any;
  @Input() load: string | undefined;

	constructor(public router: Router) {
    this.findActiveRoute(Constants.COMPONENTS_TREE);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.findActiveRoute(Constants.COMPONENTS_TREE);
  }

  findActiveRoute(navItems: any) {
    navItems.some((navItem: any) => {
      if (`/${navItem.route}` === this.router.url) {
        this.activeRoute = navItem;
        return true;
      } else if (navItem.items) {
        return this.findActiveRoute(navItem.items);
      }
      return false;
    });
  }

	navigateToHome() {
		location.reload();
	}
}
